/* eslint-disable no-unused-expressions */
// Drupal behavior that controls the display all link on species directory.
// To do, at some point the page through a pre-processor and not hard code with JS
(function speciesDirecotryScript($, Drupal) {
  Drupal.behaviors.speciesDirecotry = {
    attach(context) {
      if ($('.content-header__title').text() === 'Photo Gallery') {
        $('a').each(function (index) {
          const text = $(this).text();

          if ($(this).parents('.views-row').length) {
            switch (text) {
              case 'National':
                $(this).addClass('link link--region link--region-national');
                $(this).attr('href', `${window.location.origin}/about-us`);
                break;
              case 'International':
                $(this).addClass('link link--region link--region-international');
                $(this).attr('href', `${window.location.origin}/topic/international-affairs`);
                break;
              case 'Alaska':
                $(this).addClass('link link--region link--region-alaska');
                $(this).attr('href', `${window.location.origin}/region/alaska`);
                break;
              case 'Southeast':
                $(this).addClass('link link--region link--region-southeast');
                $(this).attr('href', `${window.location.origin}/region/southeast`);
                break;
              case 'West Coast':
                $(this).addClass('link link--region link--region-west-coast');
                $(this).attr('href', `${window.location.origin}/region/west-coast`);
                break;
              case 'Pacific Islands':
                $(this).addClass('link link--region link--region-pacific-islands');
                $(this).attr('href', `${window.location.origin}/region/pacific-islands`);
                break;
              case 'New England/Mid-Atlantic':
                $(this).addClass('link link--region link--region-mid-atlantic');
                $(this).attr('href', `${window.location.origin}/region/new-england-mid-atlantic`);
                break;
              default:
            }
          }
        });
      }
    },
  };
}(jQuery, Drupal));
